import Inline from './Inline';
import Input from './Input';
import InputBox from './InputBox';
import InputField from './InputField';
import InputLabel from './InputLabel';
Input.Inline = Inline;
Input.InputBox = InputBox;
Input.InputField = InputField;
Input.InputLabel = InputLabel;
export default Input;